import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { SearchPipe } from '@app/@shared/pipes/search.pipe';
import { NuveiBank } from '@app/@shared/services/spei.service';
import { InfiniteScrollCustomEvent, IonSearchbar, IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-bank',
  standalone: true,
  imports: [CommonModule, IonicModule, SearchPipe],
  templateUrl: './bank.component.html',
  styleUrl: './bank.component.scss',
})
export class BankComponent {
  @ViewChild('searchBank') searchBank?: IonSearchbar;
  banks: NuveiBank[] = [];
  searchTerm = '';
  items = 18;
  constructor(private modalCtrl: ModalController) {}

  ionViewDidEnter() {
    setTimeout(() => this.searchBank?.setFocus(), 400);
  }

  close() {
    this.modalCtrl.dismiss(null, 'close');
  }

  send(bank: NuveiBank) {
    this.modalCtrl.dismiss(bank, 'save');
  }

  onSearchChange(ev: any) {
    this.searchTerm = ev.detail.value;
  }

  onIonInfinite(event: InfiniteScrollCustomEvent) {
    this.items += 18;
    setTimeout(() => {
      event.target.complete();
    }, 100);
  }
}
